import { useEffect, useState } from "react";

/**
 * Whether the mobile menu drawer (#sidebar, opened from the header's three
 * dots) is on screen. On desktop the sidebar is always shown beside the page,
 * so this stays false there.
 */
const useMobileMenuOpen = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const sidebar = document.getElementById("sidebar");
    if (!sidebar) return undefined;

    const check = () =>
      setOpen(
        window.matchMedia("(max-width: 767px)").matches &&
          !sidebar.classList.contains("-translate-x-full")
      );

    check();
    const observer = new MutationObserver(check);
    observer.observe(sidebar, { attributes: true, attributeFilter: ["class"] });
    window.addEventListener("resize", check);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", check);
    };
  }, []);

  return open;
};

export default useMobileMenuOpen;
